const ALERTFREQUENCY = {
  REALTIME: 1,
  ONCEADAY: 2,
  TWICEAWEEK: 3,
}

export default {
  ALERTFREQUENCY,
}
